import { Web3Provider } from '@ethersproject/providers';

const useSignData = () => {
  const provider = new Web3Provider((window as any).ethereum);
  const signer = provider.getSigner();

  const signData = async (payload: any) => {
    const signature = await signer.signMessage(JSON.stringify(payload));
    const address = await signer.getAddress();

    return {
      payload,
      signature,
      address,
    };
  };

  return {
    signData,
  };
};

export default useSignData;
